/* Needed in many cases to override blueprint default styles. 
Very open to the idea that there's a better way to do this. */
// eslint-disable-next-line import/prefer-default-export
export const makeImportant = (val) => `${val} !important;`;
